import React from 'react';
import { Countdown } from './Countdown';
export function StickyBar() {
  return <div className="sticky top-0 z-50 bg-navy-dark text-cream-bg py-2 px-4 shadow-lg" data-id="element-335">
      
    </div>;
}